// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"28086ece","223":"84597f80","272":"e7b393f2","273":"c6fb83a8","294":"3a6d33f7","369":"63b87be4","468":"0d87e17b","534":"5f33bd71","565":"c232f7bf","710":"3db81daa"}[chunkId] + ".chunk.js";
};